import React, { PureComponent } from 'react';

class ButtonConfirmar extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {   
        const { confirmarCobranza, cobranza } = this.props;     
        return (<a className="clickable none-text-decoration glyphicon glyphicon-ok" aria-hidden="true" onClick={() => this.props.confirmarCobranza(cobranza, 2)}></a>);
    }
}

export default ButtonConfirmar;